import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const OurMotto = () => {
     useEffect(() => {
        document.title = 'Our Motto -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li> 
        <li>  School </li> 
        <li>Our Motto </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Our Motto  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <p>  The motto of the school is <b>‘Strive for Excellence’</b>. Realizing that excellence is never an accident, but the result of deliberate and intentional actions oriented towards excellence, we strive to achieve it. Excellence is our challenge, it is our goal, it is our fervent desire. We want to be considered <b> ‘ The Best ’</b> at whatever we do.</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default OurMotto
